import type { MaybeRefOrGetter } from 'vue'
import useApi from '../../components/js/Composables/useApi'
import type { Invoice } from '../../Types/invoice'
import { toValue } from 'vue'

export function useInvoice(invoiceId: MaybeRefOrGetter<number | null>) {
  const { postJSON } = useApi()

  function postInvoiceAction(action: string) {
    return async (): Promise<Invoice | null> => {
      const invoice = toValue(invoiceId)

      if (!invoice) {
        return null
      }

      return await postJSON(`invoice/${invoice}/${action}`)
    }
  }

  return {
    validate: postInvoiceAction('validate'),
    generatePayment: postInvoiceAction('generate-payment'),
  }
}
